export enum WEBSITE_TYPE {
    INTERACTIVE = 'INTERACTIVE',
    PROMO = 'PROMO'
}

export enum PROMO_SECTION_TYPE {
    HEADER = 'HEADER',
    INTRO = 'INTRO',
    VIDEO = 'VIDEO',
    SALES = 'SALES',
    FOOTER = 'FOOTER',
    CAROUSEL = 'CAROUSEL',
    STEPS = 'STEPS',
}

export const IMAGE_KEY_PREFIX = 'carouselImage-';
export const STEP_IMAGE_KEY_PREFIX = 'stepImage-';
